/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-has-content */
import {FC, useEffect} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {checkIsActive, KTIcon, toAbsoluteUrl, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'
import {useMetronicAsideHover} from '../../../../components/useMetronicAsideHover'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  className?: string
  hasBullet?: boolean
  bsTitle?: string
  outside?: boolean
  iconDynamicColor?: string
  subMenuItem?: boolean
}

const AsideMenuItem: FC<Props & WithChildren> = ({
  children,
  to,
  title,
  icon,
  fontIcon,
  className,
  bsTitle,
  outside = false,
  hasBullet = false,
  iconDynamicColor = 'bg-info',
}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  // const {aside} = config
  const onHover = useMetronicAsideHover()

  return (
    <div
      className={clsx(
        'menu-item',
        isActive && `here show mx-3 rounded-1 ${iconDynamicColor}`,
        className
      )}
    >
      {outside ? (
        <a href={to} target='_blank' className={clsx('menu-link menu-center', {active: isActive})}>
          {fontIcon && (
            <span className='menu-icon me-0'>
              {/*<i className={clsx('bi', fontIcon, 'fs-2')}></i>*/}
            </span>
          )}
        </a>
      ) : (
        <>
          <Link
            className={clsx('menu-link', {active: isActive})}
            to={to}
            data-bs-toggle='tooltip'
            data-bs-trigger='hover'
            data-bs-dismiss='click'
            data-bs-placement='right'
            data-bs-original-title={bsTitle}
          >
            {hasBullet && (
              <span className='menu-bullet'>
                <span className='bullet bullet-dot'></span>
              </span>
            )}
            {icon && (
              <span className={`menu-icon bg-transparent ${!onHover && 'w-100'}`}>
                {/*<KTIcon iconName={icon} className='fs-2' />*/}
                <img
                  src={toAbsoluteUrl(`/media/icons/menu/${icon}`)}
                  alt='logo'
                  width={35}
                  height={35}
                />
              </span>
            )}
            {onHover && (
              <span className={`mx-2 ${isActive ? 'text-white' : 'menu-title'}`}>{title}</span>
            )}
          </Link>
          {children}
        </>
      )}
    </div>
  )
}

export {AsideMenuItem}
